module.exports = __webpack_public_path__ + "img/youtube_blue.80177c2f.svg";